import React, { useState, useEffect } from 'react'
import { Tooltip, Slider, Select, Button, Input, InputNumber } from 'antd'
import { InfoCircleFilled, ToolOutlined } from '@ant-design/icons'

const SettingsContent = ({
  settings,
  updateSettings,
  handleAdvancedSettings,
  saveSettings
}) => {
  // Local state to prevent laggy updates
  const [localSettings, setLocalSettings] = useState({
    clipDuration: settings?.clipDuration || 5,
    video_prompt: settings?.video_prompt || '',
    voiceover_text: settings?.voiceover_text || '',
    lighting: settings?.lighting || ''
  })

  // Update local state when settings prop changes (e.g., when opening drawer for different shot)
  useEffect(() => {
    setLocalSettings({
      clipDuration: settings?.clipDuration || 5,
      video_prompt: settings?.video_prompt || '',
      voiceover_text: settings?.voiceover_text || '',
      lighting: settings?.lighting || ''
    })
  }, [settings?.sceneId, settings?.shotId])

  // Update local state
  const handleLocalChange = (key, value) => {
    setLocalSettings(prev => ({ ...prev, [key]: value }))
  }

  // Apply changes to parent state
  const handleApplyChanges = () => {
    console.log('Applying changes:', localSettings)
    console.log('Current settings before apply:', settings)
    // Pass all settings at once for batch update
    saveSettings(localSettings)
  }

  return (
    <div className="settings-drawer-content">
      {/* <div className="setting-group" style={{ marginBottom: 24, borderBottom: '1px solid #f0f0f0', paddingBottom: 16 }}>
                <Button
                    onClick={() => handleAdvancedSettings(settings.sceneId, settings.shotId)}
                    icon={<ToolOutlined />}
                    type="primary"
                    ghost
                    block
                    style={{ height: '40px', fontSize: '16px' }}
                >
                    Advanced Settings
                </Button>
            </div> */}
      {/* <div className="setting-group">
        <label>Clip Duration(1-8 seconds)</label>
        <InputNumber
          min={1}
          max={8}
          step={1}
          value={localSettings.clipDuration}
          onChange={value => handleLocalChange('clipDuration', value)}
        />
      </div> */}
      <div className="setting-group">
        <label>Video Prompt</label>
        <Input.TextArea
          rows={4}
          value={localSettings.video_prompt}
          onChange={e => handleLocalChange('video_prompt', e.target.value)}
          placeholder="Write your video prompt..."
        />
      </div>
      <div className="setting-group">
        <label>Voiceover Text</label>
        <Input.TextArea
          rows={4}
          value={localSettings.voiceover_text}
          onChange={e => handleLocalChange('voiceover_text', e.target.value)}
          placeholder="Write your voiceover text..."
        />
      </div>
      <div className="setting-group">
        <label>Lighting</label>
        <Input.TextArea
          rows={4}
          value={localSettings.lighting}
          onChange={e => handleLocalChange('lighting', e.target.value)}
          placeholder="Write your lighting text..."
        />
      </div>
      <Button
        type="primary"
        onClick={handleApplyChanges}
        style={{ marginTop: 16 }}
      >
        Apply Changes
      </Button>
    </div>
  )
}

export default SettingsContent
